const sevenDueDates = {
  slug: "seven-due-dates",
  title: "Seven Due Dates",
  category: "Academic Project",
  client: "Algonquin College",
  duration: "1 Week",
  cover: "/assets/vRbvWigCRAAs6gN38Olpwe6Xvo.png",
  summary: "A 60–90 second video for the Innovative Strategies course at Algonquin College, explaining the course deliverables.",
  gallery: [],
  blocks: [
    {
      type: "youtube",
      id: "etKoTyPgnnA",
      title: "Youtube Video",
    },
    {
      type: "richText",
      html: "<p><strong>A short project completed for the Innovative Strategies course: a 60–90 second video creatively demonstrating an understanding of the course deliverables. Select 4K YouTube quality for optimal viewing.</strong></p>",
    },
  ],
  relatedSlugs: ["trendless", "animatic-remastered", "2024-chasing-greatness"],
  seo: {
    title: "Seven Due Dates — Matia Dosen",
    description: "UX Designer and Creative",
  },
}

export default sevenDueDates
